import * as React from "react";
import {
  TextField,
  Show,
  NumberField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  usePermissions,
  useRecordContext,
  Title,
  SelectField,
  TopToolbar,
  EditButton,
  Button,
  useNotify,
  useDataProvider,
  useRefresh,
  LinearProgress,
} from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";
import { SimpleShowLayout } from "../common/SimpleShowLayout";
import { Archive } from "@mui/icons-material";
import { ENTITY_AVAILABILITY_STATUS } from "../enums/EntityAvailabilityStatus";
import { ENTITY_AVAILABILITY_STATUS_OPTIONS } from "../utils/EntityAvailabilityStatusUtils";

const SectionShowActions = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const [isLoading, setIsLoading] = React.useState(false);
  const refresh = useRefresh();

  const handleArchiveSection = async () => {
    notify("Archivando seccion...");
    setIsLoading(true);
    dataProvider
      .update("sections", {
        id: record.id,
        data: {
          ...record,
          status: ENTITY_AVAILABILITY_STATUS.ARCHIVED,
        },
      })
      .then(() => {
        notify("Seccion archivada con éxito", {
          type: "success",
        });
        refresh();
      })
      .catch(() => {
        notify("Ha ocurrido un error archivando la seccion", {
          type: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (isLoading) return <LinearProgress />;

  return (
    <TopToolbar>
      <EditButton  />
      {record?.status !== ENTITY_AVAILABILITY_STATUS.ARCHIVED && (
        <Button onClick={handleArchiveSection} label="Archivar">
          <Archive />
        </Button>
      )}
    </TopToolbar>
  );
};

const SectionTitle = () => {
  const record = useRecordContext();
  return <Title title={`Sección "${record?.title}"`} />;
};

const SectionShow = () => {
  const { permissions } = usePermissions();
  return (
    <Show title={<SectionTitle />} actions={<SectionShowActions />}>
      <SimpleShowLayout>
        {permissions === ROLE_TYPES.ADMIN && (
          <TextField source="id" label="ID" />
        )}
        <TextField source="title" label="Título" />
        <TextField source="type" label="Tipo" />
        <ReferenceArrayField
          label="Producto(s)"
          reference="products"
          source="products"
        >
          <SingleFieldList>
            <ChipField source="name" />
          </SingleFieldList>
        </ReferenceArrayField>
        <ReferenceArrayField
          label="Restaurante(s)"
          reference="restaurants"
          source="restaurants"
          link={false}
        >
          <SingleFieldList>
            <ChipField source="name" />
          </SingleFieldList>
        </ReferenceArrayField>
        <ReferenceArrayField
          label="Video(s)"
          reference="videos"
          source="videos"
          link={false}
        >
          <SingleFieldList>
            <ChipField source="name" />
          </SingleFieldList>
        </ReferenceArrayField>
        <NumberField source="order" label="Orden" />
        <SelectField
          label="Estado"
          source="status"
          choices={ENTITY_AVAILABILITY_STATUS_OPTIONS}
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default SectionShow;
